import React from "react";
import config from './config'
import ErrorBoundary from './components/ErrorBoundary'
import loadable from '@loadable/component'
import Spinner from '~/components/Spinner';
import { find, map } from "lodash";

const popupWhitelist = ['RichText', 'RawHtml'];

export const applyModuleData = (layouts, modules, data = null) => {
  return map(layouts, (moduleLayout) => {
    const { id, view } = moduleLayout

    const moduleData = data || find(modules, { id: id })

    const moduleName = config.mmap[view];

    if (!moduleName) {
      return console.log(`Module not found for '${view}' id '${id}'`)
    }

    if (popupWhitelist.includes(moduleName)) {
      import('./views/Popup/popup').then(popup => {
        window.popup = popup.default;
      });
    }

    const Module = loadable( (props) => import(`./modules/${props.moduleName}`),{
      fallback: Spinner
    });

    const alignment = (moduleData && moduleData.metadataMap !== null && moduleData.metadataMap && moduleData.metadataMap.align) ? moduleData.metadataMap.align : '';
    return <ErrorBoundary key={id}>
      <div className={`module ${alignment}`}>
        <Module data={moduleData} layout={moduleLayout} moduleName={moduleName} />
      </div>
    </ErrorBoundary >
  })
}

export const nestTabModules = (layouts, modules, tabModule) => {
  let footers = layouts.filter(moduleLayout => moduleLayout.view.includes("Footer"));
  let headers = layouts.filter(moduleLayout => moduleLayout.view.includes("Masthead"));
  let allOtherContent = layouts.filter(moduleLayout => !moduleLayout.view.includes('Footer') && !moduleLayout.view.includes('Masthead') && !moduleLayout.view.includes('Tabs'))

  footers = applyModuleData(footers, modules)
  headers = applyModuleData(headers, modules)
  allOtherContent = applyModuleData(allOtherContent, modules);
  tabModule = applyModuleData(tabModule, modules, allOtherContent);

  return [...headers, tabModule, ...footers]
}
